import { render, staticRenderFns } from "./StorageItem.vue?vue&type=template&id=ad1303f4&scoped=true&"
import script from "./StorageItem.vue?vue&type=script&lang=js&"
export * from "./StorageItem.vue?vue&type=script&lang=js&"
import style0 from "./StorageItem.vue?vue&type=style&index=0&id=ad1303f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1303f4",
  null
  
)

export default component.exports